module.exports = __webpack_public_path__ + "img/truck_inactive.a02193d3.svg";